export default __webpack_public_path__ + "static/media/pyre.fb53daa7.png";